<template>
  <div class="invite-root" :class="[$i18n.locale === 'ar' ? 'ar-style' : '', packageName]">
    <div class="custom-nav-block" :style="{ 'padding-top': `${barHeight}px` }">
      <van-nav-bar class="van-bar" title="" left-arrow @click-left="handleBack">
        <template #left>
          <img class="left-nav" src="@/assets/packageAssets/common/arrow02.png" alt="" />
          <span class="tit-left">{{ $t('lang.dl.agentCenter') }}</span>
        </template>
        <template #right>
          <div>
            <img class="rules-icon" src="./images/rules-tips1.png" alt="" @click.self="handleToRules" />
            <span class="policy-flag" @click.selt="handleToPolicy">{{ $t('lang.dl.policy') }}</span>
          </div>
        </template>
      </van-nav-bar>
    </div>
    <div :style="`min-height: ${barHeight + 46}px`"></div>

    <div class="invite-whole-bgc"></div>

    <div class="invite-top-bg">
      <div class="invite-bg-img">
        <img v-if="packageName === 'kiko'" src="./images/bg-kiko.png" alt="" />
        <img v-else src="./images/bg.png" alt="" />
      </div>
    </div>

    <!-- Earn up to .... -->
    <p class="earn-tips right-read" v-if="baseInfo">
      {{ $t('lang.newInvite.k002') }}
      <i class="earn-percent">{{ baseInfo.maxShareRate || '' }}%</i>
      {{ $t('lang.newInvite.k003') }}
    </p>

    <!-- Invite Hostess -->
    <div class="invite-hostess">
      <div @click="handleInvite" class="right-read">{{ $t('lang.newInvite.k001') }}</div>
    </div>

    <!-- Invitation code -->
    <div class="invite-code right-read" v-if="baseInfo" @click="handleCopyCode">
      {{ $t('lang.dl.invitationCode') }}：
      <i class="code-yellow right-read">{{ baseInfo.inviteCode || '' }}</i>
      <img src="./images/copy.png" />
    </div>

    <template v-if="baseInfo">
      <div class="invite-mybalance">
        <!-- Total Income -->
        <div class="todayincome-title right-read" @click="handleJumpInviteDetail">
          {{ $t('lang.mybean.totalIncome') }}
          <div class="income-beans">
            <img class="beans-icon" :src="getMatchImg('beans')" />
            {{ baseInfo.agentSumBean }}
          </div>
          <img class="icon-arrow-r ar-arrow" src="./images/arrow-r.png" />
        </div>
        <!-- My Balance -->
        <div class="invite-mybalance-title right-read">{{ $t('lang.wd.myBalance') }}</div>
        <div class="withdraw-info right-read">
          <div class="withdraw-info-beans">
            <img :src="getMatchImg('beans')" />
            <i class="beans-count">{{ baseInfo.walletBean }}</i>
            <i class="beans-price">
              ≈
              <i style="font-family: Inter-Regular">{{ baseInfo.currencyCode }}</i>
              {{ numberTransformK(baseInfo.currencyAmount / 100, baseInfo.locationCode) }}
            </i>
          </div>
          <div class="withdraw-info-btn" @click="handleWithdraw">{{ $t('lang.sevenKeepSignin.withdraw') }}</div>
        </div>
      </div>

      <div class="switch-tab right-read" style="position: sticky; z-index: 999" :style="`top: ${barHeight + 46}px;`">
        <div class="tab" :class="{ 'active-tab': tabIndex == tabEnmu.invite }" @click.stop="handleSwitchTab(tabEnmu.invite)">{{ $t('lang.dl.invite') }}</div>
        <div class="tab" :class="{ 'active-tab': tabIndex == tabEnmu.commission }" @click.stop="handleSwitchTab(tabEnmu.commission)">
          {{ $t('lang.dl.commission') }}
        </div>
      </div>
      <!-- Invite Tab -->
      <InviteTab v-if="tabIndex === tabEnmu.invite" :info="baseInfo" @hook:mounted="inviteTabMounted" @stepChange="stepChange" />
      <!-- Commission Tab -->
      <CommissionTab v-if="tabIndex === tabEnmu.commission" :info="baseInfo" @hook:mounted="commissionTabMounted" @stepChange="stepChange" />

      <!-- How to Earn -->
      <!-- <template v-if="baseInfo.inviteCount === 0">
        <HowtoEarn :info="baseInfo" @action="handleInvite" />
      </template> -->
    </template>

    <!-- 新手指导占位用 -->
    <div v-if="rootNewGuyGuide.show" style="width: 100%; height: 400px"></div>
  </div>
</template>

<script>
import { apiFetchInviteV2HomePage, agentGuidePageStatusSetApi, agentPageTypeApi } from '@/api/invite'
import { numberTransformK } from '@/utils/common'
import { tabEnmu } from './utils/enum'

import HowtoEarn from './components/HowToEarn.vue'
import InviteTab from './components/InviteTab.vue'
import CommissionTab from './components/CommissionTab.vue'
import config from '@/config/baseInfo'
import eventBus from '@/utils/eventbus'

// 活动指导相关
const stepOption = {
  step1: {
    targetEle: 'invite-target-aa',
    guideEle: 'invite-guide-aa'
  },
  step2: {
    targetEle: 'invite-target-ab',
    guideEle: 'invite-guide-ab'
  },
  step3: {
    targetEle: 'invite-target-ab',
    guideEle: 'invite-guide-bb'
  },
  step4: {
    targetEle: 'invite-target-cc',
    guideEle: 'invite-guide-cc'
  },
  step5: {
    targetEle: 'invite-target-dd',
    guideEle: 'invite-guide-dd'
  }
}

// 活动指导相关
const cacheDom = {
  step1: null,
  step2: null,
  step3: null,
  step4: null,
  step5: null
}

export default {
  components: {
    HowtoEarn,
    InviteTab,
    CommissionTab
  },
  props: {},
  data() {
    return {
      tabEnmu: tabEnmu,
      tabIndex: tabEnmu.invite,
      // 新手指导
      rootNewGuyGuide: {
        show: false,
        currentStep: 'step1'
      },
      // 页面数据
      baseInfo: {
        actInviteBeanReward: 0,
        actInviteEndTimeStamp: 1751241600000,
        actInviteStartTimeStamp: 1746057600000,
        agentSumBean: 0,
        commissionLevelList: [
          {
            level: 'E',
            levelRate: 5,
            maxBeans: 100000,
            minBeans: 0
          },
          {
            level: 'D',
            levelRate: 8,
            maxBeans: 300000,
            minBeans: 100000
          },
          {
            level: 'C',
            levelRate: 10,
            maxBeans: 500000,
            minBeans: 300000
          },
          {
            level: 'SS',
            levelRate: 30,
            maxBeans: 9223372036854776000,
            minBeans: 5000000
          }
        ],
        currencyAmount: 0,
        currencyCode: '',
        ifNewerGuide: false,
        inviteCode: '',
        inviteCount: 0,
        maxInviteBeanReward: 0,
        maxShareRate: 0,
        walletBean: 0,
        weekAgentCommissionBeans: 0,
        weekHostDeductionBeans: 0,
        weekHostEarningBeans: 0,
        locationCode: ''
      },
      nativeScroll: null
    }
  },
  provide() {
    return {
      newGuyGuide: this.rootNewGuyGuide
    }
  },
  methods: {
    numberTransformK: numberTransformK,
    handleBack() {
      this.closeWeb()
    },
    handleJumpInviteDetail() {
      try {
        window.ta && window.ta.track('agent_center', { Action: 'Click', APosition: 'entrance', AValue: 'details' })
      } catch (err) {
        console.log('try catch', err)
      }
      this.$router.push({ path: '/invite-history', query: { fromPage: 'invite-v2' } })
    },
    // 活动指导相关
    stepChange(arg) {
      document.body.scrollTo({ top: 0 })
      this.rootNewGuyGuide.currentStep = arg

      if (arg === 'step2' || arg === 'step3' || arg === 'step5') {
        setTimeout(() => {
          this.locationTarget()
          this.showGuide()
        }, 100)
        return
      }

      if (arg === 'step4') {
        this.tabIndex = tabEnmu.commission
      }

      if (arg === 'step6') {
        this.rootNewGuyGuide.show = false
        this.showGuide()
        // 设置新手指导状态
        agentGuidePageStatusSetApi()
      }
    },
    // 活动指导相关
    inviteTabMounted() {
      cacheDom.step1 = document.getElementById('guide-step1')
      cacheDom.step2 = document.getElementById('guide-step2')
      cacheDom.step3 = document.getElementById('guide-step3')
    },
    // 活动指导相关
    commissionTabMounted() {
      cacheDom.step4 = document.getElementById('guide-step4')
      cacheDom.step5 = document.getElementById('guide-step5')
      if (this.tabIndex === tabEnmu.commission) {
        this.locationTarget()
        this.showGuide()
      }
    },
    // 活动指导相关
    locationTarget() {
      try {
        if (this.rootNewGuyGuide.show) {
          const targetClass = stepOption[this.rootNewGuyGuide.currentStep].targetEle
          const guideClass = stepOption[this.rootNewGuyGuide.currentStep].guideEle

          if (targetClass && guideClass) {
            let targetPos = document.getElementById(targetClass)
            let guidePos = document.getElementById(guideClass)

            if (targetPos && guidePos) {
              targetPos = targetPos.getBoundingClientRect()
              guidePos = guidePos.getBoundingClientRect()

              const scrollTop = Math.abs(targetPos.top - guidePos.top)

              document.body.scrollTo({
                top: scrollTop,
                behavior: 'smooth'
              })
            }
          }
        }
      } catch (err) {
        console.log('try catch', err)
      }
    },
    // 活动指导相关
    showGuide() {
      Object.entries(cacheDom).forEach(([stepIndex, tipsDom]) => {
        if (tipsDom) {
          if (this.rootNewGuyGuide.currentStep !== stepIndex || !this.rootNewGuyGuide.show) {
            tipsDom.style.zIndex = -999
            tipsDom.style.opacity = 0
          }
          // 是当前步骤元素
          else {
            tipsDom.style.zIndex = 99999
            tipsDom.style.opacity = 1
          }
        }
      })
    },
    // 规则页面
    handleToRules() {
      try {
        window.ta && window.ta.track('agent_center', { Action: 'Click', APosition: 'entrance', AValue: 'rules' })
      } catch (err) {
        console.log('try catch', err)
      }
      this.$router.push({ path: '/invite-v2-rules', query: { fromPage: 'invite-v2' } })
    },
    // 协议页面
    handleToPolicy() {
      try {
        window.ta && window.ta.track('agent_center', { Action: 'Click', APosition: 'entrance', AValue: 'policy' })
      } catch (err) {
        console.log('try catch', err)
      }
      // 动态的政策页面
      this.$router.push({ path: '/invite-dypolicy', query: { identity: 0, language: this.$i18n.locale, fromPage: 'invite-v2' } })
    },
    handleCopyCode() {
      try {
        window.ta && window.ta.track('agent_center', { Action: 'Click', APosition: 'button', AValue: 'copy' })
      } catch (err) {
        console.log('try catch', err)
      }

      this.handleCopy(this.baseInfo.inviteCode || '', this.$t('lang.msgCopySuccss'))
    },
    // 邀请按钮
    handleInvite() {
      let lang = this.$client.getAppInfoLang()
      let address = null
      let domain = window.location.hostname || ''
      // vava
      if (this.domainNameFlag('vava', domain)) {
        address = config.address
      }
      // joychat
      else if (this.domainNameFlag('joychat', domain)) {
        address = config.addressJoychat
      }
      // echo
      else if (this.domainNameFlag('echo', domain)) {
        address = config.addressEcho
      }

      const appName = this.getAppName() || 'com.client.goparty'
      const downloadPre = address == config.addressEcho ? 'echo-' : ''
      const url = `https://${address}/#/${downloadPre}download?lang=${lang}&code=${this.baseInfo.inviteCode || ''}&appName=${appName}`

      const des = this.$t('lang.common.shareText') || "I've made 10000 beans (worth $10) here by answering calls, join me now!"

      this.$client.copyLink(`${des} # ${url}`, this.$t('lang.msgCopySuccss'))

      try {
        window.ta && window.ta.track('agent_center', { Action: 'Click', APosition: 'button', AValue: 'Invite' })
      } catch (err) {
        console.log('try catch', err)
      }

      // 通知客户端打开分享面板
      try {
        const params = {
          title: 'Vava - Live video chat',
          description: des,
          url: url
        }
        shareIntent.postMessage(JSON.stringify(params))
      } catch (error) {
        console.error(error)
      }
    },
    handleSwitchTab(index) {
      this.tabIndex = index
    },
    // 页面数据相关
    getBaseInfo() {
      apiFetchInviteV2HomePage().then((res) => {
        this.baseInfo = res || null

        // todo-调试
        // this.baseInfo.inviteCount = 0

        if (typeof this.baseInfo.inviteCount !== 'undefined') {
          try {
            window.ta && window.ta.track('agent_center', { Action: 'Display', AValue: this.baseInfo.inviteCount > 0 ? 'binded' : 'unbind' })
          } catch (err) {
            console.log('try catch', err)
          }
        }

        // 新手指导
        this.baseInfo && this.getNewGuyGuideStatus()
      })
    },
    // 新手指导状态
    getNewGuyGuideStatus() {
      let status = this.baseInfo.ifNewerGuide ? 0 : 1
      this.rootNewGuyGuide.show = !status
      // todo-调试
      // this.rootNewGuyGuide.show = true
      document.body.scrollTo({ top: 0 })
      this.$nextTick(() => {
        this.locationTarget()
        this.showGuide()
      })
    },
    handleWithdraw() {
      try {
        window.ta && window.ta.track('agent_center', { Action: 'Click', APosition: 'entrance', AValue: 'withdraw' })
      } catch (err) {
        console.log('try catch', err)
      }
      this.$router.push({
        path: '/withdrawal',
        query: {
          fromPage: 'invite-v2',
          walletType: 1
        }
      })
    },
    initNativeScroll(event) {
      let clientH = document.documentElement.clientHeight
      let scrollH = document.body.scrollHeight
      let scrollT = event.target.scrollTop
      let distance = 400

      let timer = null
      // 触底
      if (scrollT + clientH >= scrollH - distance) {
        if (!this.nativeScroll.lockLoad) {
          this.nativeScroll.lockLoad = true
          timer = setTimeout(() => {
            eventBus.$emit('InviteScroll', { type: 'arriveBottom' })
          }, 100)
        }
      }

      eventBus.$emit('InviteScroll', { type: 'scroll' })
    },
    newNativeScroll() {
      document.body.addEventListener('scroll', this.initNativeScroll)
      this.nativeScroll = {
        lockLoad: false,
        finishPullUp: function () {
          this.lockLoad = false
        },
        refresh: function () {
          // this.lockLoad = false
        }
      }
    }
  },
  created() {
    agentPageTypeApi().then((resData) => {
      this.getBaseInfo()
      let initTabIndex = '0'
      let cacheTabIndex = window.sessionStorage.getItem('inviteV2Tabindex')
      initTabIndex = cacheTabIndex || this.$route.query.tab
      if (initTabIndex) {
        window.sessionStorage.removeItem('inviteV2Tabindex')
        this.handleSwitchTab(initTabIndex)
      }

      eventBus.$on('refreshInvitePage', () => {
        this.getBaseInfo()
        this.handleSwitchTab(this.tabIndex)
      })
    })
  },
  mounted() {
    this.newNativeScroll()
  }
}
</script>

<!-- vava echo joychat -->
<style lang="scss" scoped>
.invite-root {
  width: 100%;
  padding-bottom: 20px;
  position: relative;

  .invite-whole-bgc {
    position: fixed;
    top: 0;
    background: #f1f1fc;
    width: 100%;
    height: 100vh;
    z-index: -2;
  }

  .invite-top-bg {
    width: 100%;
    height: 415px;
    background: linear-gradient(180deg, #5f2c89 0%, #3c1683 68%, #21115f 100%);
    position: absolute;
    top: 0;
    z-index: -1;
    .invite-bg-img {
      width: 100%;
      height: 100%;
      position: relative;
      img {
        width: 375px;
        height: 276px;
        position: absolute;
        left: 50%;
        bottom: 70px;
        transform: translateX(-50%);
      }
    }
  }

  .earn-tips {
    width: 325px;
    min-height: 72px;
    line-height: 36px;
    margin: 34px auto 0;
    font-family: RobotoFlex;
    font-weight: normal;
    font-size: 30px;
    letter-spacing: -2px;
    color: #ffffff;
    text-shadow: 2px 2px 0px #c800ff;
    text-align: center;
    font-style: normal;

    .earn-percent {
      font-style: italic;
      font-weight: bolder;
      font-size: 36px;
      display: inline-flex;
    }
  }

  .invite-hostess {
    width: 100%;
    margin: 30px 0 0;
    text-align: center;
    div {
      min-width: 215px;
      display: inline-block;
      min-height: 50px;
      padding: 0 10px;
      background: linear-gradient(90deg, #fff76c 0%, #ffc855 8%, #ffc956 92%, #fff96a 100%);
      box-shadow: inset 0px 2px 2px 0px #fef069, inset 0px -1px 1px 0px #e18250;
      border-radius: 100px;

      font-family: RobotoFlex;
      font-weight: normal;
      font-size: 17px;
      color: #39156f;
      line-height: 50px;
      text-align: center;
      font-weight: bolder;
    }
  }

  .invite-code {
    width: 100%;
    text-align: center;
    font-family: Inter, Inter;
    font-size: 12px;
    color: #ffffff;
    line-height: 15px;
    margin-top: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    .code-yellow {
      color: #ffe605;
    }
    img {
      width: 16px;
      height: 16px;
      box-sizing: content-box;
      border: 10px solid transparent;
    }
  }

  .invite-mybalance {
    width: 343px;
    margin: 14px auto 0;
    padding: 0 12px 16px;
    background: #ffffff;
    border-radius: 8px;
    overflow: hidden;

    .invite-mybalance-title {
      height: 18px;
      font-family: RobotoFlex;
      font-weight: 400;
      font-size: 15px;
      color: #333333;
      line-height: 18px;
      margin-top: 12px;
    }

    .withdraw-info {
      padding: 8px 0 0;
      width: 100%;
      position: relative;
      .withdraw-info-beans {
        flex: 1;
        display: inline-flex;
        align-items: center;
        flex-wrap: wrap;
        img {
          width: 25px;
          height: 25px;
        }
        .beans-count {
          margin-left: 4px;
          font-family: RobotoFlex;
          font-weight: bold;
          font-size: 30px;
          color: #333333;
          line-height: 36px;
          text-align: left;
        }
        .beans-price {
          margin-left: 4px;
          font-family: RobotoFlex;
          font-weight: 400;
          font-size: 20px;
          color: #333333;
          line-height: 30px;
          text-align: left;
          font-style: normal;
        }
      }
      .withdraw-info-btn {
        width: 243px;
        height: 34px;
        margin: 0 auto;
        background: #a338fc;
        border-radius: 24px;
        font-family: RobotoFlex;
        font-weight: normal;
        font-size: 15px;
        color: #ffffff;
        line-height: 34px;
        text-align: center;
        margin-top: 19px;
      }
    }

    .todayincome-title {
      width: 100%;
      font-family: RobotoFlex;
      font-weight: 400;
      font-size: 15px;
      color: #333333;
      line-height: 18px;
      padding: 12px 0;
      display: inline-flex;
      align-items: center;
      position: relative;
      &::after {
        content: '';
        width: 100%;
        height: 1px;
        background: #ededed;
        position: absolute;
        bottom: 0;
        left: 0;
      }
      .income-beans {
        flex: 1;
        height: 18px;
        font-family: RobotoFlex;
        font-weight: 400;
        font-size: 15px;
        color: #333333;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        .beans-icon {
          width: 15px;
          height: 15px;
          margin-right: 4px;
        }
      }
      .icon-arrow-r {
        width: 12px;
        height: 12px;
        margin-left: 4px;
      }
    }
  }

  .switch-tab {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 24px 0 10px;
    padding-bottom: 6px;
    background-color: #f1f1fc;
    .tab {
      width: 127px;
      padding: 3px 0;
      line-height: 26px;
      font-family: RobotoFlex;
      font-size: 17px;
      color: #b2b2b2;
      text-align: center;

      &.active-tab {
        color: #333333;
        position: relative;
        font-weight: bold;
        &::after {
          content: '';
          position: absolute;
          left: 50%;
          bottom: 0;
          width: 35px;
          height: 2px;
          margin-left: -17.5px;
          background-color: #333333;
        }
      }
    }
  }
}
</style>
<style lang="scss">
.invite-root {
  .custom-nav-block {
    position: fixed;
    top: 0px;
    z-index: 10000;
    background: url(./images/nav-bar-bg.png) 100% 100% / 100% 100% no-repeat;
    width: 100%;
    .van-nav-bar {
      .van-nav-bar__content {
        .van-nav-bar__left {
          .tit-left {
            font-family: RobotoFlex, RobotoFlex;
            font-weight: normal;
            font-size: 20px;
            color: #ffffff;
            line-height: 24px;
            text-align: left;
            font-style: normal;
          }
        }
        .van-nav-bar__right {
          padding: 0;
          &:active {
            opacity: 1 !important;
          }
          & > div {
            width: 95px;
            height: 100%;
            display: flex;
            justify-content: flex-end;
            align-items: center;
            .rules-icon {
              box-sizing: content-box;
              width: 20px;
              height: 20px;
              border: 8px solid transparent;
              border-right: 0;
            }

            .policy-flag {
              height: 24px;
              padding: 0 8px;
              margin-left: 16px;
              background: #ffffff;
              border-radius: 12px 0px 0px 12px;
              opacity: 0.9;

              font-family: RobotoFlex, RobotoFlex;
              font-weight: 400;
              font-size: 15px;
              color: #a338fc;
              line-height: 24px;
              text-align: center;
            }
          }
        }
      }
    }
  }
}
</style>

<!-- kiko -->
<style lang="scss" scoped>
.invite-root.kiko {
  width: 100%;
  padding-bottom: 20px;
  position: relative;

  .invite-whole-bgc {
    position: fixed;
    top: 0;
    background: #f1f1fc;
    width: 100%;
    height: 100vh;
    z-index: -2;
  }

  .invite-top-bg {
    width: 100%;
    height: 415px;
    background: linear-gradient(180deg, #ff7a00 0%, #fc4e00 50%, #fc0000 100%);
    position: absolute;
    top: 0;
    z-index: -1;
    .invite-bg-img {
      width: 100%;
      height: 100%;
      position: relative;
      img {
        width: 375px;
        height: 228px;
        position: absolute;
        left: 50%;
        bottom: 70px;
        transform: translateX(-50%);
      }
    }
  }

  .earn-tips {
    width: 325px;
    min-height: 72px;
    line-height: 36px;
    margin: 34px auto 0;
    font-family: RobotoFlex;
    font-weight: normal;
    font-size: 30px;
    letter-spacing: -2px;
    color: #ffffff;
    text-shadow: 2px 2px 0px #fb2600;
    text-align: center;
    font-style: normal;

    .earn-percent {
      font-style: italic;
      font-weight: bolder;
      font-size: 36px;
      display: inline-flex;
    }
  }

  .invite-hostess {
    width: 100%;
    margin: 30px 0 0;
    text-align: center;
    div {
      min-width: 215px;
      display: inline-block;
      min-height: 50px;
      padding: 0 10px;
      background: linear-gradient(90deg, #fff76c 0%, #ffc855 8%, #ffc956 92%, #fff96a 100%);
      box-shadow: inset 0px 2px 2px 0px #fef069, inset 0px -1px 1px 0px #e18250;
      border-radius: 100px;

      font-family: RobotoFlex;
      font-weight: normal;
      font-size: 17px;
      color: #000000;
      line-height: 50px;
      text-align: center;
      font-weight: bolder;
    }
  }

  .invite-code {
    width: 100%;
    text-align: center;
    font-family: Inter, Inter;
    font-size: 12px;
    color: #ffffff;
    line-height: 15px;
    margin-top: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    .code-yellow {
      color: #ffe605;
    }
    img {
      width: 16px;
      height: 16px;
      box-sizing: content-box;
      border: 10px solid transparent;
    }
  }

  .invite-mybalance {
    width: 343px;
    margin: 14px auto 0;
    padding: 0 12px 16px;
    background: #ffffff;
    border-radius: 8px;
    overflow: hidden;

    .invite-mybalance-title {
      height: 18px;
      font-family: RobotoFlex;
      font-weight: 400;
      font-size: 15px;
      color: #333333;
      line-height: 18px;
      margin-top: 12px;
    }

    .withdraw-info {
      padding: 8px 0 0;
      width: 100%;
      position: relative;
      .withdraw-info-beans {
        flex: 1;
        display: inline-flex;
        align-items: center;
        flex-wrap: wrap;
        img {
          width: 25px;
          height: 25px;
        }
        .beans-count {
          margin-left: 4px;
          font-family: RobotoFlex;
          font-weight: bold;
          font-size: 30px;
          color: #333333;
          line-height: 36px;
          text-align: left;
        }
        .beans-price {
          margin-left: 4px;
          font-family: RobotoFlex;
          font-weight: 400;
          font-size: 20px;
          color: #333333;
          line-height: 30px;
          text-align: left;
          font-style: normal;
        }
      }
      .withdraw-info-btn {
        width: 243px;
        height: 34px;
        margin: 0 auto;
        background: #ffe242;
        border-radius: 24px;
        font-family: RobotoFlex;
        font-weight: normal;
        font-size: 15px;
        color: #000000;
        line-height: 34px;
        text-align: center;
        margin-top: 19px;
      }
    }

    .todayincome-title {
      width: 100%;
      font-family: RobotoFlex;
      font-weight: 400;
      font-size: 15px;
      color: #333333;
      line-height: 18px;
      padding: 12px 0;
      display: inline-flex;
      align-items: center;
      position: relative;
      &::after {
        content: '';
        width: 100%;
        height: 1px;
        background: #ededed;
        position: absolute;
        bottom: 0;
        left: 0;
      }
      .income-beans {
        flex: 1;
        height: 18px;
        font-family: RobotoFlex;
        font-weight: 400;
        font-size: 15px;
        color: #333333;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        .beans-icon {
          width: 15px;
          height: 15px;
          margin-right: 4px;
        }
      }
      .icon-arrow-r {
        width: 12px;
        height: 12px;
        margin-left: 4px;
      }
    }
  }

  .switch-tab {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 24px 0 10px;
    padding-bottom: 6px;
    background-color: #f1f1fc;
    .tab {
      width: 127px;
      padding: 3px 0;
      line-height: 26px;
      font-family: RobotoFlex;
      font-size: 17px;
      color: #b2b2b2;
      text-align: center;

      &.active-tab {
        color: #333333;
        position: relative;
        font-weight: bold;
        &::after {
          content: '';
          position: absolute;
          left: 50%;
          bottom: 0;
          width: 35px;
          height: 2px;
          margin-left: -17.5px;
          background-color: #333333;
        }
      }
    }
  }
}
</style>
<style lang="scss">
.invite-root.kiko {
  .custom-nav-block {
    position: fixed;
    top: 0px;
    z-index: 10000;
    background: url(./images/nav-bar-bg-kiko.png) 100% 100% / 100% 100% no-repeat;
    width: 100%;
    .van-nav-bar {
      .van-nav-bar__content {
        .van-nav-bar__left {
          .tit-left {
            font-family: RobotoFlex, RobotoFlex;
            font-weight: normal;
            font-size: 20px;
            color: #ffffff;
            line-height: 24px;
            text-align: left;
            font-style: normal;
          }
        }
        .van-nav-bar__right {
          padding: 0;
          &:active {
            opacity: 1 !important;
          }
          & > div {
            width: 95px;
            height: 100%;
            display: flex;
            justify-content: flex-end;
            align-items: center;
            .rules-icon {
              box-sizing: content-box;
              width: 20px;
              height: 20px;
              border: 8px solid transparent;
              border-right: 0;
            }

            .policy-flag {
              height: 24px;
              padding: 0 8px;
              margin-left: 16px;
              background: #ffffff;
              border-radius: 12px 0px 0px 12px;
              opacity: 0.9;

              font-family: RobotoFlex, RobotoFlex;
              font-weight: 400;
              font-size: 15px;
              color: #ff8a33;
              line-height: 24px;
              text-align: center;
            }
          }
        }
      }
    }
  }
}
</style>

<style lang="scss">
.ar-style {
  .rules-icon {
    transform: rotateY(0deg) !important;
  }
  .policy-flag {
    margin-right: 16px;
    margin-left: 0 !important;
    border-radius: 0px 12px 12px 0px !important;
  }
}
</style>
